// extracted by mini-css-extract-plugin
export default {"wrapper":"BusinessProfile_wrapper__tO0ZX"};